
export enum XdockExceptionTypeCd {
	DAMAGED = 'Damaged',
	OVER = 'Over',
	SHORT = 'Short'}

